import { addTrackingData, generalCallbacks } from './general';
const directDebitModifierCallback = (callbackData) => {
    const data = generalCallbacks.submitModifierCallback(callbackData);
    if (data === null) {
        return null;
    }
    if (data.use_sepa === 'sepa') {
        delete data.debit_account_id;
        delete data.debit_account_owner;
        delete data.debit_bank_id;
    }
    else {
        delete data.sepa_account_owner;
        delete data.sepa_bic;
        delete data.sepa_iban;
    }
    delete data.use_sepa;
    return addTrackingData(data);
};
export const directDebitCallbacks = {
    directDebitModifierCallback,
};
